var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 38 15","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentcolor","d":"M-.166-.204l13.569 12.889a7.982 7.982 0 0010.842 0l13.463-12.7"}})])}
var staticRenderFns = []

export { render, staticRenderFns }